import React from "react";
import Icon from "../Icon";

const BackToTop = () => (
  <button
    type="button"
    title="Back To Top"
    onClick={() => {
      if (typeof window !== "undefined") {
        window.scrollTo(0, 0);
      }
    }}
    className="back-to-top"
  >
    <Icon
      className="back-to-top__arrow"
      path="arrow-right"
      width={20}
      height={20 * 0.5625}
    />
    Back to Top
  </button>
);

export default BackToTop;



// WEBPACK FOOTER //
// ./src/components/Buttons/BackToTop.js